const VISIBLE_SPECIALTY_COUNT = 2;

/** Keeps specialist identity labels compact while preserving specific specialties. */
export function summarizeSpecialties(specialties: string[]): string | null {
  if (specialties.length === 0) return null;

  const visible = specialties.slice(0, VISIBLE_SPECIALTY_COUNT).join(", ");
  const remaining = specialties.length - VISIBLE_SPECIALTY_COUNT;

  return remaining > 0 ? `${visible} +${remaining} more` : visible;
}
